import { Participant } from './participant';

export class TypeSeance {
  description: string;
  label?: string;
  defautObjetTypeId: number;
  defautObjetTypeLabel: string;
  objetTypeNonModifiable: any = false;
  couleurTexteCourrier: string;
  seanceLieuId: number;
  profilEncodageId: number;
  profilEncodageLabel: string;
  profilGestionId: number;
  profilGestionLabel: string;
  serviceProprietaireId: number;
  serviceProprietaireLabel: string;
  typeVoteId: number;
  typeVoteLabel: string;
  participants: Array<Participant> = [];
  id: number;
  value?: number;
  modeleExportWebId: any;
  participantsWebSupplementaires: Array<number> = [];
  typesPoints: Array<any> = [];
  constructor(data: any, userProfils?, services?, objets?, votes?, signatures?, groupes_pol?, roles?) {
    Object.assign(this, data);
    this.label = this.description;
    this.value = this.id;
    if (userProfils && userProfils.length > 0) {
      if (this.profilEncodageId) {
        this.profilEncodageLabel = userProfils.find((x) => x.id === this.profilEncodageId).description;
      }
      if (this.profilGestionId) {
        this.profilGestionLabel = userProfils.find((x) => x.id === this.profilGestionId).description;
      }
    }
    if (services && services.length > 0) {
      if (this.serviceProprietaireId) {
        this.serviceProprietaireLabel = services.find((x) => x.id === this.serviceProprietaireId).description;
      }
    }
    if (objets && objets.length > 0) {
      if (this.defautObjetTypeId) {
        this.defautObjetTypeLabel = objets.find((x) => x.id === this.defautObjetTypeId).description;
      }
    }
    if (votes && votes.length > 0) {
      if (this.typeVoteId) {
        this.typeVoteLabel = votes.find((x) => x.value === this.typeVoteId).label;
      }
    }
    //! à confirmer si je peux le supprimer ou pas. A priori, on entre jamais dedans car on a pas de participants dans le type de séance
    // if (this.participants && this.participants.length > 0) {
    //   this.participants.map((item) => {
    //     item.contactLabel = group.find((x) => x.id === item.contactId).description;
    //     item.typeSeance = this.description;
    //     item.groupePolitiqueLabel = groupes_pol.find((x) => x.id === item.groupePolitiqueId).description;
    //     item.signatureLabel = signatures.find((x) => x.id === item.signatureId).description;
    //     item.role = roles.find((x) => x.id === item.roleId).description;
    //   });
    // }

    if (this.typesPoints && this.typesPoints.length > 0) {
      this.typesPoints.map((item) => {
        item.typeSeance = objets.find((x) => x.id === item.objetTypeId).description;
      });
    }
  }
}
